import React from "react";
import { Entry } from "../../GratefulDB";

const EntryVenueCoverageMultiline: React.FC<{
  entry: Entry;
}> = (props): JSX.Element => {
  return (
    <div>
      <div className="sub header">Live at {props.entry.venue}</div>
      <div className="sub header">{props.entry.coverage}</div>
    </div>
  );
};

export default EntryVenueCoverageMultiline;
